import React from 'react'
import Download_app from '../common/download-app/Download_app'
import Mission_Vission from './mission-vission/Mission_Vission'
import Core_team from './core-team/Core_team'
import About_card from './about_card/About_card'
import About_Banner from './about-banner/About_Banner'

function About_Us() {
    return (
        <>
            <About_Banner />
            <About_card />
            <Mission_Vission />
            <Core_team />
            <Download_app />
        </>
    )
}

export default About_Us